export default {
  state: {
    isLogin: false,
    token: null,
    accountInfo: {},
    lastRoute: {},
  },
  getters: {
    getIsLogin: state => state.isLogin,
    getToken: state => state.token,
    getAccountInfo: state => state.accountInfo,
    getLastRoute: state => state.lastRoute,
  },
  mutations: {
    setIsLogin (state, value) {
      state.isLogin = value
    },
    setToken (state, value) {
      state.token = value
    },
    setAccountInfo (state, value) {
      state.accountInfo = value
    },
    setLastRoute (state, value) {
      state.lastRoute = value
    },
  },
}
